import { RadioButtonGroupItem, RadioButtonGroupList } from './component';

export const Radio = {
    Group: RadioButtonGroupList,
    Button: RadioButtonGroupItem,
};
